import { render, staticRenderFns } from "./AddNotification.vue?vue&type=template&id=85d2771a&scoped=true&"
import script from "./AddNotification.vue?vue&type=script&lang=ts&"
export * from "./AddNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d2771a",
  null
  
)

export default component.exports